import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import { Switch, Route } from 'react-router-dom'
import { withRouter } from 'react-router'
import { routes } from './routes'
import { GlobalStyle } from './globalStyles'
import { getVariant, changeMVTVariables } from './mvt-helper-functions'
import tracking from '../services/tracking'
import loadConfig from './loadConfig.gql'
import { enableContentful, isLive } from '../config'
import ErrorBoundary from './ErrorBoundary'
import {
  ConfigProvider,
  ConfigContext
} from '@albatross/common-components/dist/hooks/useConfigContext'

let initialLoad = true
const Main = (props) => {
  if (props?.data?.loading) return null

  const { staticContext, variant, location, venture } = props
  if (staticContext) {
    staticContext.status = 200
  }
  changeMVTVariables(location)
  useEffect(() => {
    if (!initialLoad) {
      tracking.trackPageView({
        pageviewPage: window.location.pathname,
        pageviewTitle: document.title,
        pageviewLocation: window.location.href
      })
    }
    initialLoad = false
  }, [location])
  return (
    <ConfigProvider value={props?.data?.config}>
      <GlobalStyle />
      <ErrorBoundary venture={venture} ConfigContext={ConfigContext}>
        <Switch>
          {routes &&
            routes.map((route, index) => (
              <Route
                key={index}
                render={({ _staticContext, ...props }) => {
                  return (
                    <route.comp
                      hasMargin={route.hasMargin}
                      variant={getVariant(variant)}
                      ConfigContxt={ConfigContext}
                      {...props}
                    />
                  )
                }}
                path={route.path}
                exact={Boolean(route.exact)}
              />
            ))}
        </Switch>
      </ErrorBoundary>
    </ConfigProvider>
  )
}

Main.propTypes = {
  staticContext: PropTypes.object,
  variant: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  location: PropTypes.object,
  data: PropTypes.object,
  venture: PropTypes.string
}

const MainWithData = graphql(loadConfig, {
  skip: enableContentful,
  options: () => {
    return {
      variables: {
        env: isLive ? 'live' : 'preProd'
      }
    }
  }
})(Main)

export default withRouter(MainWithData)
